import React, {useContext} from "react";

import Table from "../common/Table";
import RowPhoto from "../common/TdImg";
import Option from "../common/RowOption";

import { Link } from "react-router-dom";
import {YearContext} from "../../contexts/yearContext";

const StaffList = ({ data }) => {
  const { entryYear } = useContext(YearContext);
  const renderLink = (e) => {
    return (
      <Link
        to={`/mis/staff/${e.staff_id}/profile/salary?staffName=${e.staff_name}`}
      >
        {e.staff_name}
      </Link>
    );
  };

  const columns = [
    { path: "id", label: "شماره" },
    {
      path: "staff_photo",
      label: "عکس",
      content: ({ staff_photo }) => <RowPhoto src={staff_photo} />,
    },
    { path: "aria_id", label: "کد کارمند" },
    {
      path: "staff_name",
      label: "اسم",
      content: (e) => renderLink(e),
    },
    { path: "staff_phone", label: "شماره تماس" },
    { path: "position", label: "وظیفه" },
    { path: "section_name", label: "بخش" },
    { path: "user_status", label: "وضعیت", content: ({ user_status }) => user_status ? "برحال" : "اسبق" },
    {
      path: "option",
      content: (e) => <Option Edit={{form: "staff-form",edit: e}} Delete={{id: e.staff_id, route: 'staff'}} />
    },
  ];

  return <Table data={data} columns={columns} />;
};

export default StaffList;
